import { Carousel } from "react-bootstrap"
import React from "react"
import { Link } from "react-router-dom"

export default function PcScrollBanner(props) {
  return (
    <div className="pc-scroll-banner mw-14">
      <Carousel>
        <Carousel.Item>
          <Link to={`${props.firstLink}`}>
            <img
              className="d-block banners"
              src={props.firstImage}
              alt="First slide"
            />
          </Link>
        </Carousel.Item>
        <Carousel.Item>
          <Link to={`${props.secondLink}`}>
            <img
              className="d-block banners"
              src={props.secondImage}
              alt="Second slide"
            />
          </Link>
        </Carousel.Item>
        <Carousel.Item>
          <Link to={`${props.thirdLink}`}>
            <img
              className="d-block banners"
              src={props.thirdImage}
              alt="Third slide"
            />
          </Link>
        </Carousel.Item>
      </Carousel>
    </div>
  )
}
